import React from 'react'
import PropTypes from 'prop-types'
import DeliveryOption from '../DeliveryOption'
import { GlassShop } from '../../../functional-components/CustomSVGIcons'

const SelectedSiteToStore = ({
  showStoreSelectorModal,
  firstSiteToStoreComponent,
  secondSiteToStoreComponent,
  customStyle,
  textSize,
}) => (
  <div role="presentation" onKeyPress={showStoreSelectorModal} onClick={showStoreSelectorModal} style={customStyle}>
    <DeliveryOption
      image={<GlassShop size="small" />}
      firstLineComponent={firstSiteToStoreComponent}
      secondLineComponent={secondSiteToStoreComponent}
      theme={{
        firstTextColor: 'black',
        secondTextColor: '#fa6400',
        textSize,
      }}
    />
  </div>
)

SelectedSiteToStore.defaultProps = {
  customStyle: {},
  textSize: '14px',
  showStoreSelectorModal: () => {},
  firstSiteToStoreComponent: {},
  secondSiteToStoreComponent: {},
}

SelectedSiteToStore.propTypes = {
  showStoreSelectorModal: PropTypes.func,
  customStyle: PropTypes.object,
  firstSiteToStoreComponent: PropTypes.object,
  secondSiteToStoreComponent: PropTypes.object,
  textSize: PropTypes.string,
}

export default SelectedSiteToStore
